<template>
    <div class="mt-5 bg-white mx-4 " style="min-height: 350px;">

        <div class="row justify-content-center mt-5 card overflow-auto ">
            <div class="card-header text-primary">Create Agent</div>
            <div class="col-md-8 col-sm-12 card-body offset-2">
                <div class="alert alert-info pb-0" v-if="success">
                    <p>Agent's <b>login details</b> was sent to {{formInfo.email}}</p>
                </div>
                <div class="mt-5" v-if="!success">
                    <form action="#" @submit.prevent>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Email</label>
                                <input class="form-control" type="email" placeholder="Enter your Email" v-model.trim="$v.formInfo.email.$model"  :class="{'is-invalid':$v.formInfo.email.$error, 'is-valid':!$v.formInfo.email.$invalid}">
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Phone Number</label>
                                <input class="form-control" type="text"  placeholder="Enter your phone" v-model.trim="$v.formInfo.phone.$model"  :class="{'is-invalid':$v.formInfo.phone.$error, 'is-valid':!$v.formInfo.phone.$invalid}">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Company Name</label>
                                <input class="form-control" type="text"  placeholder="Enter Company name" v-model.trim="$v.formInfo.companyName.$model"  :class="{'is-invalid':$v.formInfo.companyName.$error, 'is-valid':!$v.formInfo.companyName.$invalid}">
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label for="rc"><span class="text-danger">*</span> Company RC</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <b class="input-group-text" id="addon-wrapping" style="font-size:13px;">RC</b>
                                    </div>
                                    <input class="form-control txt" type="text"  placeholder="Enter Company RC" v-model.number="$v.formInfo.companyRc.$model"  :class="{'is-invalid':$v.formInfo.companyRc.$error, 'is-valid':!$v.formInfo.companyRc.$invalid}">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> Address</label>
                                <input class="form-control" type="text"  placeholder="Enter Address" v-model.trim="$v.formInfo.address.$model"  :class="{'is-invalid':$v.formInfo.address.$error, 'is-valid':!$v.formInfo.address.$invalid}">
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label><span class="text-danger">*</span> City</label>
                                <input class="form-control" type="text"  placeholder="Enter city" v-model.trim="$v.formInfo.city.$model"  :class="{'is-invalid':$v.formInfo.city.$error, 'is-valid':!$v.formInfo.city.$invalid}">
                            </div>
                        </div>
                        <div class="row">
                            <div  class="col-md-6 col-sm-12 form-group mb-3">
                                <label for="stateName"><span class="text-danger">*</span>Select a State</label>
                                <select class="form-control" placeholder="Select State" v-model.trim="$v.formInfo.stateAddress.$model"  :class="{'is-invalid':$v.formInfo.stateAddress.$error, 'is-valid':!$v.formInfo.stateAddress.$invalid}">
                                    <option value="" selected>- select a state -</option>
                                    <option v-for="(state, index) in everyStates" :value="state.stateName" :key="index">{{ state.stateName }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-12 form-group mb-3">
                                <label for="tin"><span class="text-danger">*</span>Tax Identification Number</label>
                                <input class="form-control" type="text"  placeholder="Enter your Tax Identification Number" v-model.number="$v.formInfo.taxId.$model"  :class="{'is-invalid':$v.formInfo.taxId.$error, 'is-valid':!$v.formInfo.taxId.$invalid}">
                            </div>
                        </div>

                        <div class="form-group mb-3 mt-4 text-center" v-if="!sending">
                            <button class="btn btn-primary btn-sm px-5" :disabled="$v.formInfo.$invalid || hasVoted == 'true'" type="submit" @click.prevent="createAgent()"> Create Agent </button>
                            </div>
                            <div class="form-group mb-3 text-center" v-if="sending">
                            <button class="btn btn-primary btn-sm px-5" disabled type="submit" > Create Agent </button>
                        </div>

                    </form>
                </div>
            </div> <!-- end col -->
        </div>

    </div>
</template>

<script>
import { required, email, minLength} from 'vuelidate/lib/validators';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'CreateAgent',
    data() {
        return {
            formInfo: {
                email: null,
                phone: null,
                address: null,
                city: null,
                stateAddress: null,
                companyName: null,
                companyRc: null,
                taxId: null,
            },
            emes:false,
            sending:false,
            hasVoted:false,
            smes:false,
            success:false,
        };
    },
    validations: {
        formInfo: {
            email: { required, email },
            phone:{ required, minLength: minLength(9) },
            address:{ required },
            city:{ required },
            stateAddress:{ required },
            companyName:{ required },
            companyRc:{ required },
            taxId:{ required },
        }
    },

    computed:{
        ...mapState(['token']),
        ...mapGetters(['everyStates'])
    },

    methods:{
        createAgent(){
            // Only send after validations
            this.$v.formInfo.$touch()
            if (this.$v.formInfo.$invalid || this.$v.formInfo.$error) {
                // show errors
            } else {
                // submit logic
                const baseU = `${this.$urlAuth}/createagent`;

                this.$http.post(baseU, this.formInfo, {
                    headers:{
                        "x-access-token":this.token
                    }
                })
                .then((result) => {
                    if(result.data.data.code == "S201"){
                        console.log(result.data.data)
                        this.$toastr.s("Account Created Succesfully");

                        this.success = true;

                    }else if(result.data.data.code == "E301"){
                        this.$toastr.e(result.data.data.message[0], 'Error message');
                    }else if(result.data.data.code == "E200"){
                        this.$toastr.e(result.data.data.message, 'Error message');
                    }else{
                        this.$toastr.e("Unexpected Error. Please contact Admin");
                    }
                }).catch(err =>{
                    this.$toastr.e("Cannot connect to serve. Check your internet connection");
                })
            }
        }
    }
}

</script>